module.exports = __webpack_public_path__ + "media/format-selector/onsite_event@1x-017cdccf.png";